import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = ["onClick"]

import { ref, computed, watch } from 'vue';
export interface Item {
  text: string;
  value: string | number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'dropdown',
  props: {
    options: {},
    loading: { type: Boolean }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2023/02/20 14:16:09
 * @description: 自定义下拉框
 */
const props = __props;
const emits = __emit;
const initData = ref<Array<Item & { checked: boolean }>>(
  props.options.map(item => Object.assign(item, { checked: false })),
);
const data = computed<Array<Item> | undefined>(() => {
  const filter = initData.value
    .map(({ value, text, checked }) => checked && { value, text })
    .filter(Boolean) as Array<Item>;
  return filter.length ? filter : undefined;
});
const handleClick = (value: string | number) => {
  initData.value.forEach(item => {
    if (item.value === value) item.checked = !item.checked;
  });
};
watch(
  () => initData.value,
  () => emits('change', data.value),
  { deep: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(initData.value, ({ text, value, checked }) => {
      return (_openBlock(), _createElementBlock("li", {
        key: value,
        class: _normalizeClass([
        'dropdown-item',
        checked && 'dropdown-item--active',
        __props.loading && 'dropdown-item--disabled',
      ]),
        onClick: ($event: any) => (!__props.loading && handleClick(value))
      }, _toDisplayString(text), 11, _hoisted_2))
    }), 128))
  ]))
}
}

})